import { useTranslation } from "../../translation/translate";

export default function Unauthorized() {
  const { getTranslation } = useTranslation();
  return <h1>{getTranslation("NotAuthorized")}</h1>;
}
